import { render, staticRenderFns } from "./DocumentHistoryModal.vue?vue&type=template&id=582027da&"
import script from "./DocumentHistoryModal.vue?vue&type=script&lang=js&"
export * from "./DocumentHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports